import { GridColDef } from '@mui/x-data-grid-premium';
import styles from '../../../assets/styles/components/Tables/Tables.module.scss';
import { toCurrency } from '../../../utils/numberFormatter';
import { humanizeString } from '../../../utils/stringModifier';
import { Tooltip } from '@mui/material';

export const syncSuccessSummaryColumns: GridColDef[] = [
  {
    field: 'name',
    headerClassName: styles.header,
    headerName: 'Name',
    flex: 1,
    renderCell: (params) => {
      const { level, campaignName, campaignId, adset, id } = params.row;

      return (
        <div>
          <Tooltip
            title={
              level === 'campaign'
                ? `${campaignName} (${campaignId})`
                : `${adset} (${id})`
            }
          >
            {level === 'campaign'
              ? `${campaignName} (${campaignId})`
              : (`${adset} (${id})` as any)}
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: 'level',
    headerClassName: styles.header,
    headerName: 'Level',
    flex: 1,
    renderCell: (params) => {
      const { level } = params.row;

      return <div>{humanizeString(level)}</div>;
    },
  },
  {
    field: 'oldDaily',
    headerClassName: styles.header,
    headerName: 'Previous Daily Budget',
    flex: 1,
    valueGetter: (_, row) => row.oldDaily,
    renderCell: (params) => {
      const { oldDaily } = params.row;

      return <div>{toCurrency('USD', oldDaily)}</div>;
    },
  },
  {
    field: 'currentDaily',
    headerClassName: styles.header,
    headerName: 'New Daily Budget',
    flex: 1,
    valueGetter: (_, row) => row.currentDaily,
    renderCell: (params) => {
      const { currentDaily } = params.row;

      return <div>{toCurrency('USD', currentDaily)}</div>;
    },
  },
];

export const syncFailedSummaryColumns: GridColDef[] = [
  {
    field: 'adset',
    headerClassName: styles.header,
    headerName: 'Adset Name',
    flex: 1,
  },
  {
    field: 'id',
    headerClassName: styles.header,
    headerName: 'Adset ID',
    flex: 1,
  },
  {
    field: 'error',
    headerClassName: styles.header,
    headerName: 'Error',
    flex: 1,
  },
];
